import { render, staticRenderFns } from "./DashboardCustomer.vue?vue&type=template&id=01d7d9ba&scoped=true&lang=html"
import script from "./DashboardCustomer.vue?vue&type=script&lang=js"
export * from "./DashboardCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d7d9ba",
  null
  
)

export default component.exports